import 'tippy.js/dist/tippy.css'

import { plugin as VueTippy } from 'vue-tippy'

export const tippy = {
  install: (app: typeof $app) => {
    app.use(VueTippy, {
      directive: 'tippy',
      component: 'VTippy',
      componentSingleton: 'VTippySingleton',
      defaultProps: {
        allowHTML: true,
        interactive: true,
        hideOnClick: false,
      },
    })
  },
}
